import React, { useState } from 'react'
import moment from 'moment'
import PropTypes from 'prop-types'
import { useIntl, FormattedMessage } from 'react-intl'
import { Button, Typography } from '@material-ui/core'

import { SUBMIT } from 'app/constants/button'
import SubmitDialog from 'app/componentV4/Dialog/SubmitDialog'

const ExpirationDate = (props) => {
  const {
    id,
    expirationDate,
    isAction = false,
    onCancelExpiration = () => {},
  } = props
  const { formatMessage } = useIntl()
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      {moment().isBefore(expirationDate) ? (
        <div className="flex justify-between items-center">
          <Typography className="text-14 text-primary">
            <FormattedMessage
              id="timeline.detail.message.expires"
              values={{
                time: moment(expirationDate).format('LT'),
                date: moment(expirationDate).format('MMM DD, YYYY'),
                b: (text) => <b>{text}</b>,
              }}
            />
          </Typography>
          {isAction ? (
            <Button
              className="text-14 text-orange-500 normal-case py-0 h-0 hover:bg-transparent"
              disableRipple
              onClick={() => {
                setIsOpen(true)
              }}
            >
              {formatMessage({
                id: 'timeline.detail.message.button.cancle.expired',
              })}
            </Button>
          ) : null}
        </div>
      ) : (
        <Typography className="text-14 text-red-500">
          <FormattedMessage
            id="timeline.detail.message.expired"
            values={{
              time: moment(expirationDate).format('LT'),
              date: moment(expirationDate).format('MMM DD, YYYY'),
              b: (text) => <b>{text}</b>,
            }}
          />
        </Typography>
      )}
      <SubmitDialog
        id={`dialog-cancel-expiration-timeline`}
        open={isOpen}
        type={SUBMIT}
        title={formatMessage({
          id: 'notificationTimeline.card.cancelExpiration.confirm.title',
        })}
        description={formatMessage({
          id: 'timeline.detail.message.dialog.description.expires',
        })}
        submitText={formatMessage({
          id: 'text.yse.cancel',
        })}
        onSubmit={async () => {
          await onCancelExpiration(id)
          setIsOpen(false)
        }}
        closeText={formatMessage({
          id: 'text.close',
        })}
        onClose={() => setIsOpen(false)}
      />
    </>
  )
}

ExpirationDate.propTypes = {
  id: PropTypes.number,
  isAction: PropTypes.bool,
  expirationDate: PropTypes.string,
  onCancelExpiration: PropTypes.func,
}

export default ExpirationDate
